<template>
  <main class="app-main">
    <div class="app-main__inner">
      <router-view />
    </div>
  </main>
</template>

<script>
export default {
  name: 'AppMain'
}
</script>

<style lang="scss" scoped>
.app-main {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  position: relative;
  background: transparent;
  display: flex;
  flex-direction: column;
}

.app-main__inner {
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 20px 32px 20px 40px;
  display: flex;
  flex-direction: column;
}
</style>
